interface FilterGroup {
  key: "region" | "year" | "genre";
  label: string;
  options: { value: string; label: string }[];
}

interface FilterPanelProps {
  groups: FilterGroup[];
  values: Record<"region" | "year" | "genre", string>;
  onChange: (key: "region" | "year" | "genre", value: string) => void;
  onReset: () => void;
  activeCount: number;
}

export default function FilterPanel({ groups, values, onChange, onReset, activeCount }: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
        <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-filter-3-line text-accent-500" />
          筛选条件
          {activeCount > 0 && (
            <span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-accent-500 px-1 text-[10px] font-semibold text-background-50">
              {activeCount}
            </span>
          )}
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 transition-colors hover:text-accent-600 cursor-pointer whitespace-nowrap"
        >
          重置
        </button>
      </div>

      <div className="space-y-5 p-4">
        {groups.map((group) => (
          <div key={group.key}>
            <h3 className="label-caps text-[10px] text-foreground-500">{group.label}</h3>
            <div className="mt-2.5 flex flex-wrap gap-1.5">
              <button
                type="button"
                onClick={() => onChange(group.key, "all")}
                className={[
                  "rounded-md px-2.5 py-1 text-xs transition-colors cursor-pointer whitespace-nowrap",
                  values[group.key] === "all"
                    ? "bg-primary-500 font-medium text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200",
                ].join(" ")}
              >
                全部
              </button>
              {group.options.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => onChange(group.key, option.value)}
                  className={[
                    "rounded-md px-2.5 py-1 text-xs transition-colors cursor-pointer whitespace-nowrap",
                    values[group.key] === option.value
                      ? "bg-primary-500 font-medium text-background-50"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200",
                  ].join(" ")}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-background-200 p-4">
        <p className="text-[11px] leading-5 text-foreground-500">
          筛选基于站内示例数据，所有条目均可点击查看完整剧情与影评。
        </p>
      </div>
    </div>
  );
}